document.querySelectorAll('.mm-before-after').forEach(section => {
    const thumbnails = section.querySelectorAll('.mm-before-after-featured-media-image');
    const mediaSliders = section.querySelectorAll('.mm-before-after-media');
    const products = section.querySelectorAll('.mm-before-after-product');
    const leftArrow = section.querySelector('.mm-before-after-featured-media-arrow .mm-icon-chevron-left');
    const rightArrow = section.querySelector('.mm-before-after-featured-media-arrow .mm-icon-chevron-right');
    const leftArrowImage = section.querySelector('.mm-icon-chevron-left-image');
    const rightArrowImage = section.querySelector('.mm-icon-chevron-right-image');

    let currentIndex = 0;

    const updateView = (index) => {
        // Reset all
        mediaSliders.forEach(slider => {
            slider.style.display = 'none';
            slider.classList.remove('mm-active');
        });
        products.forEach(product => {
            product.style.display = 'none';
            product.classList.remove('mm-active');
        });
        thumbnails.forEach(thumb => thumb.classList.remove('mm-active'));

        // Show current
        if (mediaSliders[index]) {
            mediaSliders[index].style.display = 'flex';
            mediaSliders[index].classList.add('mm-active');
        }
        if (products[index]) {
            products[index].style.display = 'flex';
            products[index].classList.add('mm-active');
        }
        if (thumbnails[index]) {
            thumbnails[index].classList.add('mm-active');
        }

        currentIndex = index;
    };

    thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
            updateView(index);
        });
    });

    rightArrow?.addEventListener('click', () => {
        const nextIndex = (currentIndex + 1) % thumbnails.length;
        updateView(nextIndex);
    });

    leftArrow?.addEventListener('click', () => {
        const prevIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
        updateView(prevIndex);
    });

    rightArrowImage?.addEventListener('click', () => {
        const nextIndex = (currentIndex + 1) % thumbnails.length;
        updateView(nextIndex);
    });

    leftArrowImage?.addEventListener('click', () => {
        const prevIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
        updateView(prevIndex);
    });
});
